/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

export default reEvaluate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/_reEvaluate.js
// module id = null
// module chunks = 